import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { WarningTriangleIcon16Solid } from "../../../../../icons2022/WarningTriangleIcon/WarningTriangleIcon16Solid";
import { WarningTriangleIcon20Solid } from "../../../../../icons2022/WarningTriangleIcon/WarningTriangleIcon20Solid";
import { WarningTriangleIcon24Solid } from "../../../../../icons2022/WarningTriangleIcon/WarningTriangleIcon24Solid";
export var ValidationWarningIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(WarningTriangleIcon16Solid, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(WarningTriangleIcon20Solid, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(WarningTriangleIcon24Solid, null);
  }
}, 'ValidationWarningIcon');